import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { AnpHistoricalReportData, AnpHistoricalReportResponse } from "../types/anpHistoricalReport.type";

type UseAnpHistoricalReportType = ({ }: { id?: string; }) => UseQueryResult<AnpHistoricalReportData, unknown>;

const useAnpHistoricalReport: UseAnpHistoricalReportType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<AnpHistoricalReportResponse, unknown, AnpHistoricalReportData>({
    enabled: !!id,
    queryKey: ['anpReport', id],
    queryFn: () => {
      return privateAxios.get(`/anp/historical_reports/${id}`);
    },
    select: (data) => data?.data?.data,
  });
};

export default useAnpHistoricalReport;
